// HeaderRunwayStyle.jsx (modern + Bootstrap Icons only)

import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import logo from "./assets/logofinal.png";

const LANG_KEY = "weavevo_lang";

const HEADER_I18N = {
  en: {
    discover: "Discover",
    login: "Log in",
    signup: "Sign up",
    logo_alt: "Weavevo",
  },
  fr: {
    discover: "Découvrir",
    login: "Se connecter",
    signup: "S’inscrire",
    logo_alt: "Weavevo",
  },
};

function getLang() {
  if (typeof window === "undefined") return "en";
  const v = (localStorage.getItem(LANG_KEY) || "en").toLowerCase();
  return v === "fr" ? "fr" : "en";
}

const HeaderRunwayStyle = () => {
  const [scrolled, setScrolled] = useState(false);
  const [lang, setLang] = useState(getLang);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const sync = () => setLang(getLang());
    const onStorage = (e) => {
      if (e && e.key && e.key !== LANG_KEY) return;
      sync();
    };

    window.addEventListener("storage", onStorage);
    window.addEventListener("weavevo_lang_changed", sync);
    window.addEventListener("focus", sync);
    document.addEventListener("visibilitychange", sync);

    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("weavevo_lang_changed", sync);
      window.removeEventListener("focus", sync);
      document.removeEventListener("visibilitychange", sync);
    };
  }, []);

  const dict = useMemo(() => HEADER_I18N[lang] || HEADER_I18N.en, [lang]);
  const t = (k) => dict[k] ?? HEADER_I18N.en[k] ?? k;

  const headerStyle = {
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 1000,
    transition: "all 0.25s ease",
    backgroundColor: "rgba(255,255,255,0.95)",
    backdropFilter: "blur(10px)",
    boxShadow: scrolled ? "0 10px 30px rgba(15,23,42,0.08)" : "0 1px 8px rgba(15,23,42,0.06)",
    borderBottom: "1px solid rgba(15,23,42,0.06)",
  };

  return (
    <header className="py-2 px-3" style={headerStyle}>
      <div className="container d-flex justify-content-between align-items-center">
        {/* Left */}
        <div className="d-flex align-items-center gap-3">
          <Link to="/" className="d-flex align-items-center text-decoration-none">
            <img src={logo} alt={t("logo_alt")} style={{ height: "46px", objectFit: "contain" }} />
          </Link>

          <a href="https://weavevo.com/decouvrir" className="d-none d-md-inline-flex align-items-center gap-2 text-dark text-decoration-none fw-semibold">
            <i className="bi bi-compass" />
            <span>{t("discover")}</span>
          </a>
        </div>

        {/* Right */}
        <div className="d-flex align-items-center gap-2">
          <Link
            to="https://weavevo.com/"
            className="btn btn-dark rounded-pill px-3 d-inline-flex align-items-center gap-2"
            style={{ fontWeight: 700 }}
          >
            <i className="bi bi-box-arrow-in-right" />
            <span>{t("login")}</span>
          </Link>

          <a
            href="https://weavevo.com/auth/realms/master/protocol/openid-connect/auth?client_id=weavevo-frontend&redirect_uri=https%3A%2F%2Fweavevo.com%2Fauth%2Fcallback&response_type=code&scope=openid&prompt=create&kc_idp_hint="
            className="btn btn-outline-dark rounded-pill px-3 d-none d-sm-inline-flex align-items-center gap-2"
            style={{ fontWeight: 700 }}
          >
            <i className="bi bi-person-plus" />
            <span>{t("signup")}</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default HeaderRunwayStyle;
